
export enum AccountTypeEnum {
  Cheque = 1 ,
  Other,
  Savings,
  Trans,
  Credit,
  Card,
  Bond,
  'Subscription Sh',
}

export namespace AccountTypeEnum {
  export function values() {
    return Object.keys(AccountTypeEnum).filter(
      (type) => isNaN(<any>type) && type !== 'values'
    );
  }
}

